<template>
    <div class="section-h">
        <h2 class="is-size-3 is-uppercase is-underlined">Awards &amp; Recognition</h2>
        <div class="push-top push-extra">
            <div class="endpoint flex-center" v-for="endpoint in endpoints" :key="endpoint.slug">
                <router-link class="is-uppercase is-size-5 has-text-white has-text-centered" :to="{ name: 'honoree-list', params: { honor: endpoint.slug }}">
                    {{endpoint.title}}
                </router-link>
            </div>
            <div class="endpoint flex-center">
                <router-link class="is-uppercase is-size-5 has-text-white has-text-centered" to="/certificate-list">All CIF</router-link>
            </div>
            <div class="endpoint flex-center">
                <router-link class="is-uppercase is-size-5 has-text-white has-text-centered" to="/certificate-list">All League</router-link>
            </div>
        </div>
        <app-nav></app-nav>
    </div>
</template>

<script>
import Endpoints from '@/components/Endpoints.js';

export default {
  data() {
    return {
      endpoints: Endpoints.List.filter(
        obj => obj.slug !== 'hall-of-fame-inductee'
      )
    };
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/helpers.scss';

.endpoint {
  padding: 0.75em;
  &:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.2);
  }
}
</style>

